/**
 * Payments Modal
 * Shows current plan and option to purchase full scenario (Stripe placeholder)
 */

import React from 'react';
import { X, CreditCard, Check, Zap } from 'lucide-react';
import './PaymentsModal.css';

const PaymentsModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="payments-modal-overlay" onClick={onClose}>
      <div className="payments-modal" onClick={(e) => e.stopPropagation()}>
        <div className="payments-modal-header">
          <h2>Payments</h2>
          <button type="button" className="payments-modal-close" onClick={onClose} aria-label="Close">
            <X size={20} />
          </button>
        </div>
        <div className="payments-modal-content">
          <section className="payments-section">
            <h3>Current plan</h3>
            <div className="payments-plan-card">
              <div className="payments-plan-icon">
                <CreditCard size={24} />
              </div>
              <div className="payments-plan-details">
                <strong>Starter</strong>
                <p>You’ve used the $10 trial. Your current access is based on your purchase.</p>
                <div className="payments-plan-badge">
                  <Check size={14} />
                  <span>Active</span>
                </div>
              </div>
            </div>
          </section>
          <section className="payments-section">
            <h3>Upgrade</h3>
            <div className="payments-upgrade-card">
              <div className="payments-upgrade-icon">
                <Zap size={24} />
              </div>
              <div className="payments-upgrade-details">
                <strong>Full scenario access</strong>
                <p>Unlock the full scenario pack after your $10 spend. More scenarios and full curriculum.</p>
                <button type="button" className="payments-upgrade-btn" disabled>
                  Coming soon — Stripe integration
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PaymentsModal;
